import React from 'react';
import { ResponsiveContainer, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Bar } from 'recharts';

export default function ChartCore({ 
  data, 
  chartRef, 
  priceChange, 
  handleMouseMove, 
  handleMouseLeave,
  onChartHover,
  minY,
  maxY,
  children 
}) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        ref={chartRef}
        data={data}
        style={{ outline: 'none', border: 'none' }}
        tabIndex={-1}
        margin={{ top: 0, right: 25, left: 25, bottom: 0 }}
        onMouseMove={handleMouseMove}
        onMouseEnter={() => onChartHover && onChartHover(true)}
        onMouseLeave={(e) => {
          handleMouseLeave(e);
          onChartHover && onChartHover(false);
        }}
        isAnimationActive={true}
      >
        {/* 网格 */}
        <CartesianGrid 
          strokeDasharray="2 2" 
          stroke="rgba(255,255,255,0.1)" 
          horizontal={true}
          vertical={false}
        />
        
        {/* 坐标轴 */}
        <XAxis dataKey="time" hide={true} />
        <YAxis
          domain={minY && maxY ? [minY, maxY] : [
            (dataMin) => dataMin - Math.abs(dataMin) * 0.22,
            (dataMax) => dataMax + Math.abs(dataMax) * 0.15
          ]}
          hide={true}
        />
        
        {/* 成交量专用隐藏 Y 轴 */}
        <YAxis
          yAxisId="volume"
          orientation="right"
          hide
          domain={[0, Math.max(...data.map(d => d.volume || 0)) * 7 || 10]}
        />
        
        {/* 提示框 */}
        <Tooltip 
          content={({ active, payload }) => {
            if (active && payload && payload.length) {
              return (
                <div className="bg-gray-800 px-2 py-1 rounded text-xs text-white border border-gray-600">
                  {payload[0].value.toLocaleString()}
                </div>
              );
            }
            return null;
          }}
          cursor={{ fill: 'transparent' }}
        />
        
        {/* 主线条 */}
        <Line 
          type="monotone" 
          dataKey="price" 
          stroke={priceChange?.startsWith('+') ? '#10b981' : priceChange?.startsWith('-') ? '#ef4444' : '#6b7280'}
          strokeWidth={1.5}
          dot={false}
          activeDot={false}
          animationDuration={0}
        />
        

        
        {/* 子组件插槽 */}
        {children}
      </LineChart>
    </ResponsiveContainer>
  );
}
